import { HallOfFameGameCard } from "components/discover/HallOfFameGameCard";
import { BlockHeading } from "components/landing-pages/BlockHeading";
import { HallOfFameBlock } from "dtos/content/landing-pages/HallOfFameBlock";

export const HallOfFameBlockDisplay = (props: { block: HallOfFameBlock }) => {
    const { block } = props;
    const { items, actionText, actionUrl, heading, actionNewTab } = block;

    return (
        <div className="grid">
            {heading && (
                <div className="g-col-12">
                    <BlockHeading block={block} />
                </div>
            )}

            {items.map(item => (
                <div className="g-col-12 g-col-lg-4" key={item.code}>
                    <div className="vstack gap-3">
                        {item.heading && <h3 className="h5">{item.heading}</h3>}

                        <HallOfFameGameCard game={item} />
                    </div>
                </div>
            ))}

            {actionText && actionUrl && (
                <div className="g-col-12 text-center">
                    <a className="btn btn-primary" href={actionUrl} target={actionNewTab ? "_blank" : "_self"}>
                        {actionText}
                    </a>
                </div>
            )}
        </div>
    );
};
